export default __webpack_public_path__ + "static/media/c003-right-lady.104980a5.png";